import React from 'react';

export const slickOurProductDetails = {
  LENSES: {
    title: 'Daily Contact Lenses',
    desc: ' Our contact lenses are designed for optimum comfort and moisture.',
    imgLens: 'block',
    imgDrops: 'hidden',
    imgBlg: 'hidden',
    image: 'our-product-lens.png',
    transition: 'lens-transition',
    content: '',
    content_mobile: '',
    toggle: 'hidden',
    displayPopUp: ' block',
  },
  DROPS: {
    title: 'Hydration Drops',
    desc:
      ' Our premium Swiss quality drops provide maximum hydration for hard-working eyes.',
    image: 'our-product-drops.png',
    imgLens: 'hidden',
    imgDrops: 'block',
    imgBlg: 'hidden',
    content: '',
    content_mobile: '',
    toggle: 'block',
    transition: 'drops-transition',
    displayPopUp: ' hidden',
  },
  BLG: {
    title: 'Blue Light Glasses',
    desc:
      'Our Blue Light Glasses block the highest frequency of blue light, emitted from everyday devices such as cell phones and computer screens. ',
    image: 'our-product-blg.png',
    imgLens: 'hidden',
    imgDrops: 'hidden',
    imgBlg: 'block',
    content: '',
    transition: 'blg-transition',
    content_mobile: (
      <div className="border-b-2 border-white border-t-2 py-5 mt-8 border-opacity-30  ">
        <p className="text-white font-light text-base">
          Our glasses can help to minimize the risks of:
        </p>
        <div className="text-white text-base mt-3 flex flex-row justify-between w-full">
          <p className="text-white text-base w-1/3 border-r border-waldo-tangerine">
            screen-related eye strain
          </p>
          <p className="text-white w-1/3 border-r border-waldo-tangerine pl-3">
            sleep cycle disruption
          </p>
          <p className="text-white text-base w-1/3 pl-3">
            macular degeneration
          </p>
        </div>
      </div>
    ),
    toggle: 'hidden',
    displayPopUp: ' hidden',
  },
};
